import { useMutationObserver } from "@vueuse/core";
import { computed, readonly, ref } from "vue";

export type Theme = "light" | "tonal";

const documentElement = globalThis.document.documentElement;
const readTheme = (): Theme => (documentElement.dataset.theme === "tonal" ? "tonal" : "light");
const currentTheme = ref<Theme>(readTheme());

useMutationObserver(
    documentElement,
    () => {
        currentTheme.value = readTheme();
    },
    { attributes: true, attributeFilter: ["data-theme"] },
);

export const theme = readonly(currentTheme);
export const tonalThemeEnabled = computed(() => theme.value === "tonal");
